export default __webpack_public_path__ + "static/Schedule-1966d36d8554cce740c0842b4ae0b9e8.png";